import ErrorIcon from '@mui/icons-material/Error';
import { useActaDetalleStore } from "../../../../../store/actaDetalleStore";
import InfoActa from "../../../../../views/modals/ModalActaDetalle2/components/InfoActa";
import TabImagenes from "../TabImagenes";
import InfoActa2 from '../../../../../views/modals/ModalActaDetalle2/components/InfoActa2';
import PersonIcon from '@mui/icons-material/Person';
import DriveEtaIcon from '@mui/icons-material/DriveEta';
import Opcion from '../../../../../views/modals/ModalActaDetalle/OpcionesActaDetalle2/Opcion';
import { useLocation } from 'react-router-dom';
import { getInitialState, hasRole } from '../../../../../context/handlers';
import { Alert, Button } from 'react-bootstrap';
import { useGeneralAppStore } from '../../../../../store/generalAppStore';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import { format, parse, parseISO } from 'date-fns';
import { useContext } from 'react';
import { UserContext } from '../../../../../context';

const TabInformacion2 = ({ opciones }) => {
    const { actaDetalle, alertas, acta, archivos } = useActaDetalleStore();
    const { handlerModal } = useGeneralAppStore();
    const { pathname } = useLocation();
    const { actions } = useContext(UserContext);

    return (
        <>
            <div className="mx-auto " >
                <section className="row">
                    <div className='col-6' style={{ maxWidth: "600px" }}>
                        <div className='row'>
                            <div className='col-6' style={{ maxWidth: "300px" }}>
                                <InfoActa2 opciones={opciones} />
                            </div>
                            <div className="col-6" style={{ maxWidth: "300px" }}>
                                {/* <InfoActa2 /> */}
                                <div className='' >
                                    {/* <h5 className="m-0 ps-2 pe-5 mb-2 text-light bg-primary py-1 " style={{ borderBottom: "1px solid gray", width: "fit-content", lineHeight: "10px" }}>Titular</h5> */}
                                    <p className='m-0 text-primary fw-bold mb-2'><PersonIcon />Titular</p>

                                    <div className="">
                                        <div className="d-flex flex-column gap-2">
                                            <p className={`fw-medium m-0 `} style={{ fontSize: "12px ", color: '#374151' }}>Domicilio electrónico: <span style={{ fontSize: "14px", color: '#111827' }} className={`${!acta.domicilio_notificacion_id && "text-danger"} fw-bold  `}>{acta.domicilio_notificacion_id ?? "No tiene"}</span></p>
                                            <p className={`fw-medium m-0 ${alertas.some(alerta => alerta.label == "documento_titular") && 'bg-danger-subtle'}`} style={{ fontSize: "12px ", color: '#374151' }}>DNI: <span style={{ fontSize: "14px", color: '#111827' }} className="fw-bold  text-dark">{acta.documento_titular ?? ""}</span>{alertas?.some(alerta => alerta.label == "documento_titular") && <ErrorIcon sx={{ color: "#DC3545" }} />}</p>
                                            <p className={`fw-medium m-0 `} style={{ fontSize: "12px ", color: '#374151' }}>Razón Social: <span style={{ fontSize: "14px", color: '#111827' }} className="fw-bold  text-dark">{acta.razonSocial ?? ""}</span></p>
                                            <p className={`fw-medium m-0 ${alertas.some(alerta => alerta.label == "direccion_titular") && 'bg-danger-subtle'}`} style={{ fontSize: "12px ", color: '#374151' }}>Dirección: <span style={{ fontSize: "14px", color: '#111827' }} className="fw-bold  text-dark">{acta.direccion_titular ?? ""}</span>{alertas?.some(alerta => alerta.label == "direccion_titular") && <ErrorIcon sx={{ color: "#DC3545" }} />}</p>
                                            <p className={`fw-medium m-0 ${alertas.some(alerta => alerta.label == "provincia") && 'bg-danger-subtle'}`} style={{ fontSize: "12px ", color: '#374151' }}>Provincia: <span style={{ fontSize: "14px", color: '#111827' }} className="fw-bold  text-dark">{acta.provincia ?? ""}</span>{alertas?.some(alerta => alerta.label == "provincia") && <ErrorIcon sx={{ color: "#DC3545" }} />}</p>
                                            <p className={`fw-medium m-0 ${alertas.some(alerta => alerta.label == "localidad") && 'bg-danger-subtle'}`} style={{ fontSize: "12px ", color: '#374151' }}>Localidad: <span style={{ fontSize: "14px", color: '#111827' }} className="fw-bold  text-dark">{acta.localidad ?? ""}</span>{alertas?.some(alerta => alerta.label == "localidad") && <ErrorIcon sx={{ color: "#DC3545" }} />}</p>
                                            <p className={`fw-medium m-0 ${alertas.some(alerta => alerta.label == "codigo_postal") && 'bg-danger-subtle'}`} style={{ fontSize: "12px ", color: '#374151' }}>Código postal: <span style={{ fontSize: "14px", color: '#111827' }} className="fw-bold  text-dark">{acta.codigo_postal ?? ""}</span>{alertas?.some(alerta => alerta.label == "codigo_postal") && <ErrorIcon sx={{ color: "#DC3545" }} />}</p>
                                        </div>
                                    </div>

                                    {/* <h4 className="m-0 ps-2 pe-5 mb-2 text-light bg-primary py-1 " style={{ borderBottom: "1px solid gray", width: "fit-content", lineHeight: "14px" }}>Vehiculo</h4> */}
                                    <p className='m-0 mb-2 mt-4 text-primary fw-bold'><DriveEtaIcon />Vehiculo</p>
                                    <div className="">
                                        <div className="d-flex flex-column gap-2">
                                            <p className={`fw-medium m-0 `} style={{ fontSize: "12px ", color: '#374151' }}>Marca: <span style={{ fontSize: "14px" }} className="fw-bold  text-dark">{acta.marca_vehiculo ?? ""}</span></p>
                                            <p className={`fw-medium m-0 `} style={{ fontSize: "12px ", color: '#374151' }}>Modelo: <span style={{ fontSize: "14px" }} className="fw-bold  text-dark">{acta.modelo_vehiculo ?? ""}</span></p>
                                            <p className={`fw-medium m-0 `} style={{ fontSize: "12px ", color: '#374151' }}>Patente: <span style={{ fontSize: "14px", color: '#111827' }} className="fw-bold  text-dark">{acta.plate ?? ""}</span></p>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>

                        {
                            acta?.estado_id == 4 &&
                            <Alert variant="success" className="col-12  m-0  my-4">
                                <div className='bg-white w-100 p-4 pt-3 rounded'>
                                    <p className="m-0 text-center "><b>Acta notificada</b></p>
                                    <hr className="mt-1" />
                                    <div className="d-flex flex-column gap-2">
                                        {
                                            acta?.fecha_notificacion &&
                                            <span style={{ fontSize: "12px" }}>Fecha de notificación: <b style={{ fontSize: "14px" }}>{format(parse(acta?.fecha_notificacion, 'yyyy-MM-dd HH:mm:ss', new Date()), 'dd/MM/yy HH:mm')}</b></span>
                                        }
                                        {
                                            acta?.tipo_acta_generada == "FISICA" && acta?.notificador &&
                                            <span style={{ fontSize: "12px" }}>Notificador: <b style={{ fontSize: "14px" }}>{acta?.notificador?.persona.nombre}</b></span>
                                        }
                                    </div>
                                </div>
                            </Alert>
                        }
                        {
                            acta?.estado_id == 11 &&
                            <Alert variant="success" className="col-12  m-0 my-4">
                                <div className='bg-white w-100 p-4 pt-3 rounded'>
                                    <p className="m-0 text-center "><b>Acta abonada</b></p>
                                    <hr className="mt-1" />
                                    <div className="d-flex flex-column gap-2">
                                        {
                                            acta?.fecha_notificacion &&
                                            <span style={{ fontSize: "12px" }}>Fecha de notificación: <b style={{ fontSize: "14px" }}>{format(parse(acta?.fecha_notificacion, 'yyyy-MM-dd HH:mm:ss', new Date()), 'dd/MM/yy HH:mm')}</b></span>
                                        }
                                        {
                                            acta?.tipo_acta_generada == "FISICA" && acta?.notificador &&
                                            <span style={{ fontSize: "12px" }}>Notificador: <b style={{ fontSize: "14px" }}>{acta?.notificador?.persona.nombre}</b></span>
                                        }
                                    </div>
                                </div>
                            </Alert>
                        }
                        {
                            acta?.estado_id == 13 &&
                            <Alert variant="dark" className="col-12  w-100 m-0 my-4" >
                                <div className='bg-white w-100 p-4 pt-3 rounded'>
                                    <p className="m-0 text-center "><b>Acta en descargo</b></p>
                                    <hr className="mt-1" />
                                    <div className="d-flex flex-column gap-2">
                                        {
                                            acta?.fecha_descargo &&
                                            <span style={{ fontSize: "12px" }}>Fecha de descargo: <b style={{ fontSize: "14px" }}>{format(parseISO(acta?.fecha_descargo), "dd/MM/yy HH:mm")}</b></span>
                                        }
                                        {
                                            acta?.observacion_descargo &&
                                            <span style={{ fontSize: "12px" }}>Observación: <b style={{ fontSize: "14px" }}>{acta?.observacion_descargo}</b></span>
                                        }

                                    </div>
                                </div>
                            </Alert>
                        }
                        {
                            acta?.estado_id == 15 &&
                            <Alert variant="dark" className="col-12  m-0 my-4" >
                                <div className='bg-white w-100 p-4 pt-3 rounded'>
                                    <p className="m-0 text-center "><b>Acta en tribunales</b></p>
                                    <hr className="mt-1" />
                                    <div className="d-flex flex-column gap-2">
                                        {
                                            acta?.baja_tribunal == 1
                                                ?
                                                <span className="text-center"> Esta <b>marcado</b> en baja tribunal</span>
                                                :
                                                <span className="text-center"> <b>No</b> esta marcado en baja tribunal</span>
                                        }

                                        <div className="text-center">
                                            {
                                                acta?.baja_tribunal == 0 &&
                                                <Button size="sm" variant="dark" onClick={() => handlerModal({ modal: true, modalName: "baja_tribunal" })}>Baja tribunal</Button>
                                            }
                                        </div>

                                    </div>
                                </div>
                            </Alert>
                        }
                        {
                            // acta?.estado_id == 19 &&
                             acta?.dictamenes &&
                            <Alert variant="dark" className="col-12  m-0 my-4" style={{ backgroundColor: "#FFCDFF" }} >
                                <div className='bg-white w-100 p-4 pt-3 rounded'>
                                    <p className="m-0 text-center "><b>Dictamen</b></p>
                                    <hr className="mt-1" />
                                    <div className="d-flex flex-column gap-2">
                                        {
                                            acta?.dictamenes?.map((dictamen) => {
                                                return (


                                                    <div key={dictamen.id} className='mb-0'>
                                                        <div className='d-flex flex-column gap-2'>
                                                            <p className='mb-0 fw-bold'>N° Expediente: <span className='fw-light'>{dictamen?.numero_expediente}</span></p>
                                                            <p className='mb-0 fw-bold'>Onservación: <span className='fw-light'>{dictamen?.observacion}</span></p>
                                                        </div>
                                                        <hr className='m-0 mb-3 mt-2' />
                                                    </div>
                                                )
                                            }, [])
                                        }

                                    </div>
                                </div>
                            </Alert>
                        }


                    </div>

                    <div className="col">
                        {/* {
                            !pathname.includes('buscar-acta') ?
                                <TabImagenes />
                                :

                                (hasRole('admin', getInitialState().user) || hasRole('admin.app', getInitialState().user))
                                    ?
                                    <TabImagenes />
                                    :
                                    <>
                                        {
                                            archivos?.actas
                                                ?
                                                <object data={archivos?.actas[archivos?.actas?.length - 1]?.file} type='application/pdf' className='w-100' style={{ aspectRatio: '3/4', maxHeight: "650px" }} />
                                                :
                                                <TabImagenes />
                                        }
                                    </>
                        } */}
                        <TabImagenes />
                    </div>

                </section >

            </div >
        </>
    );
}

export default TabInformacion2;
